<template>
  <div class="page-box decision-box">
    <div class="decision-head">
      <div class="decision-head-left">飞行中故障后风险评估</div>
      <div class="decision-head-right">
        <div class="decision-head-bt" @click="historyErroyRecord"><img src="@/assets/images/yi.png"/>历史记录</div>
        <div class="decision-head-bt active" @click="$router.push('/index')"><img src="@/assets/images/yi2.png"/>回到首页
        </div>
      </div>
    </div>
    <div class="decision-pages">
      <div class="state-head" v-if="this.handleVO.socReview === 'R3'">
        已反馈
        <div class="state-bt" @click="opendialogVisible()">查看模拟机数据</div>
      </div>
      <div class="state-head active" v-if="this.handleVO.socReview === 'R1'">
        模拟机处理中...
        <div class="state-bt" @click="opendialogVisible()">查看模拟机数据</div>
      </div>
      <div class="state-head active2" v-if="this.handleVO.socReview === 'R2'">
        申请模拟机不通过
        <!--        <div class="state-bt" @click="opendialogVisible()">查看模拟机数据</div>-->
      </div>
      <div class="state-head active2" v-if="this.handleVO.socReview === 'R5'">
        系统拒绝
      </div>
      <div class="ac3" v-if="this.handleVO.socReview === 'R2'">评估后无需启用模拟机，请继续按计划飞行。</div>
      <div class="Commitanalogdata-box">
        <div class="Commitanalogdata-left">
          <div class="simulation-box">
            <!--模拟机处理中-->
            <div class="clz" v-if="this.handleVO.socReview === 'R1'">
              <img src="@/assets/images/ff1.png"/>
              <div class="clz-p">模拟机处理中</div>
            </div>
            <!--模拟机处理中-->
            <div class="clz" v-if="this.handleVO.socReview === 'R2'">
              <img src="@/assets/images/ff2.png"/>
              <div class="clz-p">申请模拟机不通过</div>
            </div>
            <div class="clz" v-if="this.handleVO.socReview === 'R5'">
              <img src="@/assets/images/ff2.png"/>
              <div class="clz-p">系统拒绝</div>
            </div>
            <div class="simulation-nav" v-if="this.handleVO.socReview === 'R3' ">
              <div class="simulation-li" :class="active===1?'active':''" @click="active=1">空中故障模拟</div>
              <div class="simulation-li" :class="active===2?'active':''" @click="active=2">A机场降落模拟</div>
              <div class="simulation-li" :class="active===3?'active':''" @click="active=3">B机场降落模拟</div>
              <div class="simulation-li" :class="active===4?'active':''" @click="active=4">C机场降落模拟</div>
            </div>
            <div class="simulation-page" v-if="this.handleVO.socReview === 'R3'">
              <!--              <wss-player v-if="stream!==null" :stream="stream" @reconnect="reconnect"/>-->
              <div class="upload-box">
                <!--                  <video src="http://127.0.0.1:8080/nfs/TabPlaneRiskRecordHandleVideoFileDTO/b98817022c9f55629d444b2200b8ffbf.mp4"></video>-->
                <video controls v-if="videoUrl" :key="videoUrl">
                  <source :src="videoUrl" type="video/mp4"/>
                </video>
                <!--                <div v-if="active===1" class="operation-time">{{handleVO.simulationAirVideo.url}}</div>-->
                <!--                <div v-if="active===2" class="operation-time">{{handleVO.simulationAVideo.url}}</div>-->
                <!--                <div v-if="active===3" class="operation-time">{{handleVO.simulationBVideo.url}}</div>-->
                <!--                <div v-if="active===4" class="operation-time">{{handleVO.simulationCVideo.url}}</div>-->
                <!--                <div class="operation-bt"><img src="@/assets/images/index/ic6.png"/>重新播放</div>-->
              </div>
            </div>
          </div>
        </div>
        <div class="Commitanalogdata-right">
          <div class="fauldetails-ul">
            <div class="fauldetails-li">
              <div class="fauldetails-head">航班信息</div>
              <div class="fauldetails-bottom">
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">飞机型号</div>
                  <div class="fauldetails-right">{{ this.handleVO.planeType }}</div>
                </div>
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">航班号</div>
                  <div class="fauldetails-right">{{ this.handleVO.flightNo }}</div>
                </div>
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">飞机编号</div>
                  <div class="fauldetails-right">{{ this.handleVO.msn }}</div>
                </div>
              </div>
            </div>
            <div class="fauldetails-li">
              <div class="fauldetails-head">故障信息</div>
              <div class="fauldetails-bottom">
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">故障照片</div>
                  <div class="fauldetails-right"><span
                    @click="clickCarousel()">{{
                      (this.handleVO.errorImages !== undefined && this.handleVO.errorImages.length > 0) ? '查看 >' : '暂无图片'
                    }}</span>
                  </div>
                </div>
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">故障信息</div>
                  <div class="fauldetails-right">{{ this.handleVO.fullFaultMessage }}</div>
                </div>
                <!--                <div class="fauldetails-laber">-->
                <!--                  <div class="fauldetails-left">飞机状态</div>-->
                <!--                  <div class="fauldetails-right"></div>-->
                <!--                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog :visible.sync="dialogVisible">
        <div class="parameter-modal">
          <div class="parameter-modal-head">模拟机参数信息</div>
          <div class="parameter-modal-box">
            <div class="parameter-ul">
              <div class="parameter-left">
                当前位置信息
              </div>
              <div class="parameter-right">
                <div class="parameter-li">
                  <div class="parameter-head">
                    longitude 纬度
                  </div>
                  <div class="parameter-name">
                    {{ this.handleVO.latitude }}
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    longitude 经度
                  </div>
                  <div class="parameter-name">
                    {{ this.handleVO.longitude }}
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    altitute 海拔高度
                  </div>
                  <div class="parameter-name">
                    {{ this.handleVO.height }}
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    风量
                  </div>
                  <div class="parameter-name">
                    {{ this.handleVO.air }}
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    温度
                  </div>
                  <div class="parameter-name">
                    {{ this.handleVO.temperature }}
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    真航向
                  </div>
                  <div class="parameter-name">
                    {{ this.handleVO.trueSailing }}
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    校正空速
                  </div>
                  <div class="parameter-name">
                    {{ this.handleVO.airspeed }}
                  </div>
                </div>
              </div>
            </div>
            <div class="parameter-ul">
              <div class="parameter-left">
                飞机重量信息
              </div>
              <div class="parameter-right">
                <div class="parameter-li">
                  <div class="parameter-head">
                    零燃油重量(单位:t)
                  </div>
                  <div class="parameter-name">
                    {{ this.handleVO.zeroFuelWeight }}<span>t</span>
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    FUFEL 当前燃油重量(单位:t)
                  </div>
                  <div class="parameter-name">
                    {{ this.handleVO.fuelWeight }}<span>t</span>
                  </div>
                </div>
                <div class="parameter-li">
                  <div class="parameter-head">
                    CG重心
                  </div>
                  <div class="parameter-name">
                    {{ this.handleVO.cg }}<span>%</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="parameter-ul">
              <div class="parameter-left">
                备降信息
              </div>
              <div class="parameter-right" style="display: block;">
                <div v-for="(item,index) in handleVO.airports"
                     style="display: flex;flex-wrap: wrap;justify-content: center;flex:1;">
                  <div class="parameter-li">
                    <div class="parameter-head">
                      备降候选机场{{ index + 1 }}
                    </div>
                    <div class="parameter-name">
                      {{ item.airport }}
                    </div>
                  </div>
                  <div class="parameter-li">
                    <div class="parameter-head">
                      预计到达时间
                    </div>
                    <div class="parameter-name">
                      {{ item.arriveTime }}
                    </div>
                  </div>
                  <div class="parameter-li">
                    <div class="parameter-head">
                      预计到达重量
                    </div>
                    <div class="parameter-name">
                      {{ item.arriveWeight }}
                      <span>t</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <Carousel v-if="carouselDialog" :showDialog="carouselDialog" @handle-close="closeCarousel" :imgs="imgs"></Carousel>
    <div class="left-box">
      <el-dialog
        :visible="dialogVisible2"
        :before-close="closeHistory"
        @open="planeRiskRecordHistory"
        @close="queryHistory.number=1"
      >
        <div class="history-page">
          <div class="history-head">历史记录</div>
          <div class="history-input">
            <el-input @keyup.enter.native="changeHistoryList()" v-model="paramsHistory.flightNo"
                      placeholder="请输入关键词搜索"></el-input>
          </div>
          <div class="history-ul" @scroll="loadHistory($event)">
            <div class="history-li" v-for="(item,index) in errorRecordHistoryList" :key="item.id">
              <div class="history-top">
                <div class="history-text">
                  <div class="history-h">{{ item.fullFaultMessage }}</div>
                  <div class="history-p">{{ item.createTimeFormat }}</div>
                </div>
                <div class="history-bt" @click="goMalfunction(item)">进入查看</div>
              </div>
              <div class="history-bottom">
                <div class="history-laber">
                  <div class="history-left">记录状态</div>
                  <div v-if="item.socReview==='R0'" class="history-right active3">{{
                      SocReviewEnum[item.socReview]
                    }}
                  </div>
                  <div v-if="item.socReview==='R1'" class="history-right active4">{{
                      SocReviewEnum[item.socReview]
                    }}
                  </div>
                  <div v-if="item.socReview==='R2'" class="history-right active">{{
                      SocReviewEnum[item.socReview]
                    }}
                  </div>
                  <div v-if="item.socReview==='R3'" class="history-right active2">{{
                      SocReviewEnum[item.socReview]
                    }}
                  </div>
                  <div v-if="item.socReview==='R4'" class="history-right active4">{{
                      SocReviewEnum[item.socReview]
                    }}
                  </div>
                  <div v-if="item.socReview==='R5'" class="history-right active">{{
                      SocReviewEnum[item.socReview]
                    }}
                  </div>
                </div>
                <div class="history-laber">
                  <div class="history-left">记录编号</div>
                  <div class="history-right">{{ item.id }}</div>
                </div>
                <div class="history-laber">
                  <div class="history-left">飞机型号</div>
                  <div class="history-right">{{ item.planeType }}</div>
                </div>
                <div class="history-laber">
                  <div class="history-left">航班号</div>
                  <div class="history-right">{{ item.flightNo }}</div>
                </div>
                <div class="history-laber">
                  <div class="history-left">飞机编号</div>
                  <div class="history-right">{{ item.msn }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!--入口-->
    <div class="entrance-icon" @click="resultModalVisible=true">
      <img src="@/assets/images/m9.png"/>
    </div>
    <!--收起-->
    <!--    <div class="entrance-icon2">
          <img src="@/assets/images/m10.png"/>
        </div>-->
    <!--模拟结果总结-->
    <resultModal v-if="resultModalVisible"
                 v-model="resultModalTxt"
                 :visible.sync="resultModalVisible"
                 :record-id="this.param.recordId"/>
    <!--输入展开-->
    <resulttextModal v-if="resulttextModalVisible" :visible.sync="resulttextModalVisible"/>
    <!--文字总结记录-->
    <SummaryrecordModal v-if="SummaryrecordModalVisible" :visible.sync="SummaryrecordModalVisible"/>
    <!--总结备选库-->
    <alternativeModal v-if="alternativeModalVisible" :visible.sync="alternativeModalVisible"/>
  </div>
</template>

<script>
import isUndefined from 'lodash/isUndefined'
import isNull from 'lodash/isNull'
import {getHandle, planeRiskRecordHistory} from "@/api/api";
import Carousel from "@/components/Carousel.vue";
import WssPlayer from "@/components/player/WssPlayer.vue";
import {getDeviceHikStreamVO} from "@/api/kecang";
import HikStreamVO from "@/components/player/HikStreamVO";

import resultModal from "@/components/summarize/resultModal";
import resulttextModal from "@/components/summarize/resulttextModal";
import SummaryrecordModal from "@/components/summarize/SummaryrecordModal";
import alternativeModal from "@/components/summarize/alternativeModal";
import fulltextModal from "@/components/summarize/fulltextModal";
import MixinMqttClient from "@/components/mqtt/MixinMqttClient";

// https://localhost:9527/#/simulator/IpBIbpOS1IwOEkgE6oFUiA
export default {
  name: "decision",
  components: {WssPlayer, Carousel, resultModal, resulttextModal, SummaryrecordModal, alternativeModal, fulltextModal},
  mixins: [MixinMqttClient],
  data() {
    return {
      videoUrl: '',
      resultModalVisible: false,
      resultModalTxt: '',
      resulttextModalVisible: false,
      SummaryrecordModalVisible: false,
      alternativeModalVisible: false,
      dialogVisible: false,
      dialogVisible2: false,
      carouselDialog: false,
      active: 1,
      param: {
        recordId: ''
      },
      res: {},
      handleVO: {
        latitude: '',
        longitude: '',
        height: '',
        air: '',
        airports: [],
        simulationAirVideo: {url: '', name: '', uname: '-'},
        simulationAVideo: {url: '', name: '', uname: '-'},
        simulationBVideo: {url: '', name: '', uname: '-'},
        simulationCVideo: {url: '', name: '', uname: '-'},
      },
      errorRecordHistoryList: [],
      isHistory: false,
      isScrollHistory: true,
      SocReviewEnum: {
        R0: "申请中",
        R1: "模拟机处理中",
        R2: "不通过",
        R3: "已反馈",
        R4: "SOC确认信息",
        R5: "系统拒绝"
      },
      queryHistory: {
        number: 1,
        limit: 10,
      },
      paramsHistory: {
        flightNo: "CSN",
        orderBy: JSON.stringify([{"name": "id", "direction": "DESC"}])
      },
      stream: null,
    }
  },
  created() {
    this.param.recordId = this.$route.params.id
    this.getHandle();
  },
  mounted() {
    this.subscribeTopic()
  },
  beforeDestroy() {
    if (this.topic){
      this.unsubscribeMQTT(this.topic)
    }
  },
  computed: {
    activeCamera() {
      switch (this.active) {
        // case 1:
        //   return this.handleVO.simulationAir // 空中故障模拟
        // case 2:
        //   return this.handleVO.simulationA // A机场降落模拟
        // case 3:
        //   return this.handleVO.simulationB // B机场降落模拟
        // case 4:
        //   return this.handleVO.simulationC // C机场降落模拟
      }
    },
    activeCameraTitle() {
      return this.activeCamera.title || '-'
    },
    enableMQTT() {
      if (this.disabledMQTT) {
        return false;
      }
      if (isUndefined(this.handleVO.socReview) || isNull(this.handleVO.socReview)) {
        return false;
      }
      if (["R2", "R3", "R5"].includes(this.handleVO.socReview)) {
        // R0: "申请中",
        // R1: "模拟机处理中",
        // R2: "不通过",
        // R3: "已反馈",
        // R4: "SOC确认信息",
        // R5: "系统拒绝"
        return false;
      }
      if (!this.param.recordId) {
        return false;
      }
      return true;
    },
    topic() {
      return this.enableMQTT ? `PlaneRiskRecordService/${this.param.recordId}` : "";
    }
  },
  watch: {
    active: {
      handler(val, oldVal) {
        // this.playHikStream()
        this.changeUrl()
      }
    },
    enableMQTT(newValue){
      if (newValue) {
        this.subscribeTopic()
      } else if (this.topic) {
        this.unsubscribeMQTT(this.topic);
      }
    },
    topic(newValue, oldValue) {
      if (newValue) {
        this.subscribeTopic();
      } else if (oldValue) {
        this.unsubscribeMQTT(oldValue);
      }
    }
  },
  methods: {
    changeUrl() {
      if (this.handleVO != null) {
        if (this.active === 1) {
          this.videoUrl = this.handleVO.simulationAirVideo === undefined ? '' : this.handleVO.simulationAirVideo.url
        } else if (this.active === 2) {
          this.videoUrl = this.handleVO.simulationAVideo === undefined ? '' : this.handleVO.simulationAVideo.url
        } else if (this.active === 3) {
          this.videoUrl = this.handleVO.simulationBVideo === undefined ? '' : this.handleVO.simulationBVideo.url
        } else {
          this.videoUrl = this.handleVO.simulationCVideo === undefined ? '' : this.handleVO.simulationCVideo.url
        }
      }
    },
    initCamera(handleVO) {
      // if (!handleVO.simulationAir) {
      //   handleVO.simulationAir = {begin: '', end: '', title: '-'}
      // }
      // this.formatCameraTime(handleVO.simulationAir)
      //
      // if (!handleVO.simulationA) {
      //   handleVO.simulationA = {begin: '', end: '', title: '-'}
      // }
      // this.formatCameraTime(handleVO.simulationA)
      //
      // if (!handleVO.simulationB) {
      //   handleVO.simulationB = {begin: '', end: '', title: '-'}
      // }
      // this.formatCameraTime(handleVO.simulationB)
      //
      // if (!handleVO.simulationC) {
      //   handleVO.simulationC = {begin: '', end: '', title: '-'}
      // }
      // this.formatCameraTime(handleVO.simulationC)
      // return handleVO
    },
    /**
     *
     * @param camera {object}
     */
    formatCameraTime(camera) {
      const arrs = ['', '']
      if (camera.begin) {
        arrs[0] = camera.begin.substring(8).replace(/(\d{2})(\d{2})(\d{2})/, (match, h, m, s) => `${h}:${m}:${s}`)
      }
      if (camera.end) {
        arrs[1] = camera.end.substring(8).replace(/(\d{2})(\d{2})(\d{2})/, (match, h, m, s) => `${h}:${m}:${s}`)
      }
      camera.title = `${arrs[0]}-${arrs[1]}`
    },
    async getHandle() {
      const res = await getHandle(this.param)
      console.log(res)
      if (res.code === 'A00000') {
        this.handleVO = res.data[0]
        // this.updateVideoUrl()
        this.changeUrl()
      }
    },
    // updateVideoUrl() {
    //   this.$set(this, 'videoUrl', this.handleVO.simulationAirVideo.url);
    // },
    opendialogVisible() {
      this.dialogVisible = true
    },
    clickCarousel() {
      this.imgs = this.handleVO.errorImages ? this.handleVO.errorImages : []
      if (this.handleVO.errorMedia) {
        this.handleVO.errorMedia.forEach(media => {
          this.imgs.push(media)
        })
      }
      if (this.imgs.length === 0) {
        this.$message.warning("暂无故障照片/信息");
      }
      this.carouselDialog = this.imgs.length > 0
    },
    closeCarousel() {
      this.carouselDialog = false
    },
    subscribeTopic() {
      if (this.enableMQTT && this.topic) {
        this.subscribeMQTT(this.topic, (message) => {
          this.onMessage(message);
        });
      }
    },
    onMessage(message) {
      if (message) {
        getHandle(this.param).then(res => {
          console.log(res)
          if (res.code === 'A00000') {
            this.handleVO = res.data[0]
            // this.updateVideoUrl()
            this.changeUrl()
          }
        })
      }
    },

    loadHistory(e) {
      const sHeight = e.target.scrollHeight
      const sTop = e.target.scrollTop
      const cHeight = e.target.clientHeight
      if (sTop + cHeight + 50 >= sHeight && this.isScrollHistory) {
        this.morePageHistory()
      }
    },
    changeHistoryList() {
      if (this.paramsHistory.flightNo === '') {
        this.paramsHistory.flightNo = null;
      }
      console.log(this.paramsHistory)
      this.errorRecordHistoryList = [];
      this.planeRiskRecordHistory()
    },
    async planeRiskRecordHistory() {
      this.isScrollHistory = false
      const res = await planeRiskRecordHistory(this.queryHistory, this.paramsHistory)
      if (res.code === 'A00000' && res.data.length) {
        if (this.queryHistory.number === 1) {
          this.errorRecordHistoryList = res.data
        } else {
          this.errorRecordHistoryList = [...this.errorRecordHistoryList, ...res.data]
        }
        this.isScrollHistory = true
        if (res.data.length < 10) {
          this.isScrollHistory = false
          //  this.$message.info('已全部加载完')
        }
      } else {
        this.isScrollHistory = false
      }
    },
    historyErroyRecord() {
      this.planeRiskRecordHistory()
      this.dialogVisible2 = true
    },
    morePageHistory() {
      this.queryHistory.number++
      this.planeRiskRecordHistory()
    },
    goMalfunction(item) {
      // R0: "申请中",
      // R1: "模拟机处理中",
      // R2: "不通过",
      // R3: "已反馈",
      // R4: "SOC确认信息",
      // R5: "系统拒绝"
      if (['R0', 'R4'].includes(item.socReview)) {
        this.$router.push(`/Commitanalogdata/${item.id}`)
      } else {
        this.$router.push(`/simulator/${item.id}`)
      }
    },
    closeHistory() {
      this.dialogVisible2 = false
    },
    handler(val, oldVal) {
      // this.playHikStream()
      this.changeUrl();
    },
    // 获取视频播放地址
    async playHikStream() {
      const {begin, end, cameraIndexCode} = this.activeCamera
      if (!cameraIndexCode) {
        console.log(['playHikStream', this.activeCamera])
        return
      }
      if (!(begin && end)) {
        console.log(['playHikStream', this.activeCamera])
        return
      }
      const result = await getDeviceHikStreamVO(cameraIndexCode, 'wss', begin, end)
      console.log(['result', result])
      if (result.code === 'A00000') {
        if (result.rowCount > 0) {
          this.stream = new HikStreamVO({key: cameraIndexCode, ...result.data[0]})
        } else {
          this.stream = null
          // this.$message.error('视频播放加载失败，请确认设备是否正常注册到平台')
        }
      } else {
        this.stream = null
        console.error(`视频播放地址获取失败：${result.message}`)
        // this.$message.error(result.message)
      }
    },
    // 播放断开重连
    reconnect({key, protocol}) {
      console.log({key, protocol})
      this.playHikStream()
    },
  },
}
</script>

<style lang="less">
#player {
  left: 0;
}
</style>
<style lang="less" scoped>
.entrance-icon:before {
  position: absolute;
  content: '';
  width: 8px;
  height: 8px;
  background: #E9463C;
  border-radius: 50%;
  right: 0px;
  top: 0px;
}

.entrance-icon2 {
  position: fixed;
  box-shadow: 0px 6px 12px 0px #050913;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #262D40;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 24px;
  right: 24px;
  cursor: pointer;

  img {
    width: 20px;
  }
}

.entrance-icon {
  position: fixed;
  box-shadow: 0px 6px 12px 0px #050913;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #1556D7;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 24px;
  right: 24px;
  cursor: pointer;

  img {
    width: 20px;
  }
}

.simulation-page {
  display: block;
  position: relative;

  video {
    height: 42vw;
  }

  .upload-box {
    position: absolute;
    height: 42vw;
    width: 100%;
    border: 0.5px dashed rgba(255, 255, 255, 0.6);
    border-radius: 8px;

    .upload-img {
      cursor: pointer;

      img {
        width: 44px;
        margin-bottom: 12px;
      }

      span {
        display: block;
        font-size: 14px;
        opacity: 0.6;
      }
    }
  }
}

.Commitanalogdata-right {
  width: 450px;
  flex: initial;

  .fauldetails-ul {
    padding: 0;
  }
}

.simulation-page {
  position: relative;
}

.operation-box {
  position: absolute;
  height: 100%;
  z-index: 999;
  right: 0;
  top: 0;
  width: 1px;

  .operation-time {
    top: 20px;
    right: 20px;
    position: absolute;
    font-size: 24px;
    color: #000;
    font-weight: bold;
    width: 300px;
    text-align: right;
    -webkit-text-stroke: 1px #fff;
  }

  .operation-bt {
    position: absolute;
    width: 130px;
    bottom: 20px;
    right: 20px;
    background: #164B9A;
    border: 1px solid #164B9A;
    height: 40px;
    cursor: pointer;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #fff;
    align-items: center;

    img {
      width: 16px;
      margin-right: 8px;
    }
  }
}

.Commitanalogdata-left {
  flex: 1;
  width: auto;
}

.parameter-li {
  width: calc(33.3% - 16px);
}

.fauldetails-bt-box {
  position: relative;

  .fauldetails-bt {
    border: 1px solid rgba(255, 255, 255, 0.6);
    color: rgba(255, 255, 255, 0.6);
  }

  .fauldetails-bt.active {
    border: 1px solid #1F60C1;
    color: #fff;
  }
}

.decision-pages {
  display: block;
}

/deep/ .left-box .el-dialog__wrapper {
  display: block;

  .el-dialog {
    border-radius: 0;
  }
}

/deep/ .left-box .el-dialog {
  margin: 0 !important;
  background: #262D40;
  height: 100vh;
  width: 600px;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
    color: #fff;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 20px;
  }

  .el-dialog__headerbtn {
    top: 22px;
  }
}

.history-head {
  padding: 24px 16px;
  font-size: 24px;
  text-align: left;
  line-height: 20px;
}

.history-input {
  background: #131B33;
  width: calc(100% - 32px);
  margin: auto;
  height: 45px;
  display: flex;
  align-items: center;
  border-radius: 8px;

  /deep/ .el-input__inner {
    background: none;
    color: #fff;
  }
}

.history-bottom {
  padding: 24px;

  .history-laber:last-child {
    margin-bottom: 0;
  }

  .history-laber {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    .history-left {
      opacity: 0.87;
      font-size: 14px;
    }

    .history-right {
      opacity: 0.9;
      font-size: 16px;
    }

    .history-right.active {
      color: #E07073;
    }

    .history-right.active2 {
      color: #8EBF86;
    }

    .history-right.active3 {
      color: #EBA967;
    }

    .history-right.active4 {
      color: #2769EC;
    }
  }
}

.history-ul {
  padding: 16px;
  border-top: 1px solid #171E2F;
  margin-top: 20px;
  height: calc(100vh - 136px);
  padding-bottom: 0;
  box-sizing: border-box;
  overflow: auto;

  .history-li {
    background: #393F52;
    border: 1px solid #525F89;
    border-radius: 16px;
    margin-bottom: 16px;

    .history-top {
      display: flex;
      padding: 24px;
      justify-content: space-between;
      border-bottom: 1px solid #000000;

      .history-text {
        text-align: left;
        width: 370px;

        .history-h {
          font-size: 16px;
          color: rgba(255, 255, 255, 0.87);
          margin-bottom: 10px;
        }

        .history-p {
          color: rgba(255, 255, 255, 0.7);
          font-size: 12px;
        }
      }

      .history-bt {
        background: #4E5569;
        border-radius: 8px;
        font-size: 14px;
        cursor: pointer;
        padding: 0 20px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/simulator/simulator.vue